import React, { useState, useEffect } from 'react';
import {Button,Form, Modal, Alert, Spinner} from 'react-bootstrap';
import "../../styles/css/ConnectionForm.css";
import micro_reporter_api from '../../apis/micro-reporter-api';
import NavigationBar from '../NavigationBar';
import noSource from '../../assets/img/server.png';
import SideNavigation from "../SideNavigation";
import Connection from "./Connection";
import searchImage from "../../assets/img/search.png";
import Utils from "../../libraries/utils";

const ConnectionList = () => {

    const [showErrorMessage, setShowErrorMessage] = useState(false);
    let errorMessage = "An unexpected error was encountered!";

    const [connections, setConnections] = useState([]);
    const [tempConnections, setTempConnections] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [deleteConnectionVars, setDeleteConnectionVars] = useState({deleteValues: {connectionName: "", connectionId: ""}});
    const [hasNoReport, setHasNoReport] = useState(true);
    const [count, setCount] = useState(10);
    const [showLoad, setShowLoad] = useState(false);
    useEffect(() => {
        
        getConnections();
    }, []);

    const getConnections = () =>{
      let projectId = new URLSearchParams(window.location.search).get("projectId");
      if(projectId){
        getAllConnectionsByProjectId(projectId);
      }else{
        // getAllConnections();
      }
    };

    const getAllConnectionsByProjectId = (projectId) =>{
      (async () => {
        try{
            Utils.loadingScreen("show");
            setShowLoad(true);
            await micro_reporter_api.get('/micro-reporter/database/find-by-project-id?projectId=' + projectId).then(
                (response) => {
                    setConnections(response.data);
                    setTempConnections(response.data);
                    Utils.loadingScreen("hide");
                    setShowLoad(false);
                }
            )
        }catch{
            Utils.loadingScreen("hide");
            setShowErrorMessage(true);
            setShowLoad(false);
        }
    })();
    };

    const getAllConnections = () => {
        (async () => {
            try{
                Utils.loadingScreen("show");
                await micro_reporter_api.get('/micro-reporter/database/all').then(
                    (response) => {
                        setConnections(response.data);
                        setTempConnections(response.data);
                        Utils.loadingScreen("hide");
                    }
                )
            }catch{
                Utils.loadingScreen("hide");
                setShowErrorMessage(true);
            }
        })();
    };

    const preDeleteConnection = (id, connName) => {
        let user = JSON.parse(localStorage.getItem("user"));
        (async () => {
            try{
                Utils.loadingScreen("show");
                await micro_reporter_api.get(`micro-reporter/report/find-by-database-id?dcid=${id}&userId=${user.id}`).then(
                    (response) => {
                        setDeleteConnectionVars({deleteValues: {connectionName: connName, connectionId: id}});
                        if(response.data.list.length>0){
                            setHasNoReport(false);
                            setModalShow(true);
                        }else{
                            setHasNoReport(true);
                            setModalShow(true);
                        }
                        Utils.loadingScreen("hide");
                    }
                );
            }catch{
                Utils.loadingScreen("hide");
                setShowErrorMessage(true);
            }
        })();
    };

    const deleteConnection = () => {
        if(deleteConnectionVars.deleteValues.connectionName !== ""){
            (async () => {
                try{
                    Utils.loadingScreen("show");
                    let user = JSON.parse(localStorage.getItem("user"));
                    let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(deleteConnectionVars.deleteValues.connectionName), "relatedId": deleteConnectionVars.deleteValues.connectionId};
                    const config = {headers};
                    await micro_reporter_api.delete(`/micro-reporter/database/delete?name=${deleteConnectionVars.deleteValues.connectionName}`, config).then(
                        () => {
                            window.location.reload();
                            Utils.loadingScreen("hide");
                        }
                    );
                }catch (err){
                    Utils.loadingScreen("hide");
                    setShowErrorMessage(true);
                }
            })();
        }
    };

    const renderTable = () => {
        if (tempConnections.length > 0) {
            return(
                <div>
                    {renderList(tempConnections.slice(0, count))}
                </div>
            );
        } else if(tempConnections.length == 0 && !showLoad){
            return(
                <div id="record-not-found-div">
                    <div id="center-div">
                        <img src={noSource} style={{width: "100px", marginTop: "20px", marginBottom: "15px"}} alt="No db connection found."/>
                        <br/>
                        <span>No database connection found, create a new one!</span>
                    </div>
                </div>
            );
        }
    };
    
    const renderList = (connections) => {
        return connections.map(connection => {
            return(
                <Connection preDeleteConnection={preDeleteConnection} connection={connection}></Connection>
            );
        });
    };

    const renderNewButton = () => {
        let projectId = new URLSearchParams(window.location.search).get("projectId");
        return(
            <Button variant="primary" id="connection-add-button" style={{padding:"0", height:"38.4px", float: "right", marginTop: "-38px", backgroundColor: "#6c976c", borderColor: "#6c976c"}}>
                <a className="link" href={"/connection/form?projectId="+projectId}>
                    Create
                </a>
            </Button>
        );
    };

    const loadMore = () => {
        let limit = tempConnections.length > count ? true:false;
        if (limit){
            setCount(count+10);
        }
    };

    const renderLoadMoreButton = () => {
        let limit = tempConnections.length > count ? true:false;
        if (limit){
            return(
                <div>
                    <Button variant="outline-primary" style={{width: "33%", marginLeft: "auto", marginRight: "auto", display: "block", marginTop: "30px"}} onClick={() => {loadMore()}}>Load More Connections</Button>
                </div>
            )
        }
    };

    const search = (word) => {
        let temp = [];
        connections.map(connection => {
            if (connection.databaseConnectionName.toLowerCase().includes(word.toLowerCase())){
                temp.push(connection);
            }
        });
        setTempConnections(temp);
        temp = [];
        setCount(10);
    };

    return(
        <div>
            <SideNavigation current="sources"/>
            <div className="page-order">
                <NavigationBar />
                <div id="connection-form-panel">
                    <div style={{marginBottom: "35px", width: "100%"}}>
                        <h5 className="page-title">Database Connections</h5>
                        {renderNewButton()}
                        <Form>
                            <input type="text" name="search" id="userSearchInput" onChange={(event) => search(event.target.value)} placeholder="Search Connection" className="extand"/>
                            <img id="seacrhIcon" src={searchImage} alt="search" />
                        </Form>
                    </div>
                    {showErrorMessage ?
                        (
                            <Alert variant="danger">
                                {errorMessage}
                            </Alert>
                        ) : null
                    }
                    {renderTable(connections)}
                     {renderLoadMoreButton()}
                </div>
            </div>
            <DeleteConnectionModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                delete={deleteConnection}
                setDeleteConnectionVars={setDeleteConnectionVars}
                hasNoReport={hasNoReport}
                setHasNoReport={setHasNoReport}
            />
        </div>
    );
};

function DeleteConnectionModal(props){
    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span id="connection-form-panel-title">Delete Database Connection</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{padding: "5px 15px 5px "}}>
                    {props.hasNoReport ? "Are you sure want to delete this connection?":"Reports found associated with this database. Are you sure want to delete this connection?"}
                </div>
                <div></div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.delete}>
                    {props.hasNoReport ? "Delete": "Delete Anyway"}
                </Button>
                <Button variant="success" onClick={()=>{
                    props.setDeleteConnectionVars({deleteValues: {connectionName: "", connectionId: ""}});
                    props.setHasNoReport(true);
                    props.onHide();
                }}
                >
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};


export default ConnectionList;
